import { createLocalStorageItem } from 'src/domains/layouts/state/localStorage/createLocalStorageItem';
import { LocalStorageItemState } from 'src/domains/layouts/state/localStorage/LocalStorageItemState';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';
import * as t from 'io-ts';

const decodeIO = t.union([
    t.string,
    t.null
]);
const decode = buildValidator('localStorage.promoCode', decodeIO, true);

export const localStoragePromoCode = (withAutorun: boolean, key: string): LocalStorageItemState<string|null> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: null
    });
};
